import React, { FunctionComponent } from "react";
import Placeholder, { PlaceholderProps } from "./Placeholder";
import imageSrc from "./Gallery.png";

const GalleryPlaceholder: FunctionComponent<PlaceholderProps> = (props) => {
	const {
		children,
		titleProps,
		subtitleProps,
		...otherProps
	} = props;

	const childrenProp = children || {};

	if (!childrenProp.image) {
		childrenProp.image = (
			<img src={imageSrc} />
		);
	}

	let galleryPlaceholderTitleProps = titleProps;
	let galleryPlaceholderSubtitleProps = subtitleProps;
	if (!titleProps) {
		galleryPlaceholderTitleProps = { res: "ViewPlaceholderTitleNoResult" };
		galleryPlaceholderSubtitleProps ||= { res: "ViewPlaceholderDescriptionNoResult" };
	}

	return (
		<Placeholder
			subtitleProps={galleryPlaceholderSubtitleProps}
			titleProps={galleryPlaceholderTitleProps}
			{...otherProps}
		>
			{childrenProp}
		</Placeholder>
	);
};

export default GalleryPlaceholder;
